export default __webpack_public_path__ + "static/media/HowItWorks4.ba64961d.png";